import TurfDiseaseRiskMap from "./TurfDiseaseRiskMap";

export default TurfDiseaseRiskMap;